"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var react_components_1 = require("@lws/react-components");

var util_1 = require("@lws/react-components/dist/components/RichTextRenderer/renderers/util");

var _SubSection_1 = require("@lsg/components/lib/components/atoms/Section/_SubSection");

var Grid_1 = require("@lsg/components/lib/components/atoms/Grid/Grid");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var BenefitsList_1 = require("./BenefitsList");

exports.BenefitsSection = function (_a) {
  var data = _a.data,
      id = _a.id;
  var headline = data.richText('headline');
  var overline = data.text('overline');
  var leadText = data.richText('leadText');
  var picture = data.asset('picture');
  var benefitsList = data.array('benefitsList');
  var separatorBottom = data["boolean"]('separatorBottom', true);
  return react_1["default"].createElement(components_1.Section, {
    separatorBottom: separatorBottom,
    fullWidth: false,
    id: id
  }, react_1["default"].createElement(components_1.Grid, null, react_1["default"].createElement(GridRow_1.GridRow, null, react_1["default"].createElement(components_1.TextSection, {
    label: overline,
    title: headline && react_1["default"].createElement("span", null, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
      content: headline,
      options: util_1.footnotesFragmentsOptions
    }))
  }, leadText && react_1["default"].createElement(components_1.Paragraph, null, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
    content: leadText,
    options: util_1.footnotesFragmentsOptions
  })))), react_1["default"].createElement(GridRow_1.GridRow, null, react_1["default"].createElement(GridColumn_1.GridColumn, {
    xl: 8,
    lg: 8,
    md: 8,
    sm: 12,
    xs: 12
  }, react_1["default"].createElement(_SubSection_1.SubSection, null, react_1["default"].createElement(BenefitsList_1.BenefitsList, {
    data: benefitsList
  }))), picture && react_1["default"].createElement(GridColumn_1.GridColumn, {
    xl: 4,
    lg: 4,
    md: 4,
    sm: 12,
    xs: 12,
    verticalAlign: Grid_1.VerticalAlign.MIDDLE
  }, react_1["default"].createElement(react_components_1.LsgPicture, {
    fluidData: picture.fluid(),
    alt: picture.title(),
    maxWidth: 400,
    style: {
      margin: 'auto'
    }
  })))));
};